import { NgModule } from '@angular/core';
import { EngagementApiUtilsModule } from '@epicuro-next/data/engagement/engagement-api-utils';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { SessionStateModule } from '@epicuro-next/state/session-state';

import {
  CommercialListApiService,
  LookbookApiService,
  NewsfeedApiService,
  ProductListApiService,
  ProductListExportApiService,
  ProductListProductsApiService,
} from './services';

@NgModule({
  imports: [EngagementApiUtilsModule, SessionStateModule],
  providers: [
    ProductListApiService,
    ProductListExportApiService,
    LookbookApiService,
    NewsfeedApiService,
    CommercialListApiService,
    ProductListProductsApiService,
  ],
})
export class DataEngagementApiModule {}
